import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Icon } from "@iconify/react";
import { Image } from "react-bootstrap";
import IMAGES from "../constants/images";
import { Link } from "react-router-dom";
import Modals from "inc/Modals";
import { useUserRole } from "services/provider";

const CommonModal = ({
  body,
  show,
  title,
  onClose,
  para,
  className,
  image,
  paraStyle,
  setModalType,
  preventClose = false, // ✅ NEW PROP to block backdrop/ESC
}) => {
  const { setRole } = useUserRole();
  return (
    <Modal
      show={show}
      centered
      size="md"
      onHide={() => {
        if (!preventClose) {
          onClose();
        }
      }}
      className={`loginModal ${className}`}
      backdrop={preventClose ? "static" : true} // ✅ Prevent backdrop close
      keyboard={!preventClose} // ✅ Prevent ESC key close
    >
      <Modal.Body>
        <div className="modal-body2">
          {image && (
            <Image
              src={IMAGES.short_logo}
              alt="Logo"
              className="img-fluid logoModal"
            />
          )}
          <div className="header_Modal">
            <h1>{title}</h1>
            <p style={{ ...paraStyle }}>{para}</p>
          </div>
          {body}

          {onClose && (
            <Icon
              icon="radix-icons:cross-2"
              width="25"
              height="25"
              onClick={(e) => {
                e.preventDefault();
                onClose();
              }}
              className="cursor-pointer closeIcon"
            />
          )}
        </div>
        {preventClose && (
           
            <div className="d-flex justify-content-between align-items-center" style={{ borderTop: "1px solid #0000001A" }}>
              <p style={{ borderRight: "1px solid #0000001A",margin: "0", padding: " 1em" ,color:"#1D1D1F"}}>
                Sign Up as <Link style={{color: "#e91515" ,fontWeight: "bold"}} onClick={() => {
                  setRole("user")
                  setModalType("signup")
                }}>User</Link>
              </p>
              <p style={{ margin: "0", padding: "1em" ,color:"#1D1D1F"}}>
                Sign Up as <Link style={{color: "#e91515" ,fontWeight: "bold"}} onClick={() => {
                  setRole("vendor")
                  setModalType("signup")
                }}>Vendor</Link>
              </p>
          </div>
        )}
      </Modal.Body>

   
    </Modal>
  );
};

export default CommonModal;
